import { mutatorAction } from "satcheljs";
import getBrandSubscriptionStoreForAccount from "../store/Store";
import getBrandsSubscriptionsService from "../services/getBrandsSubscriptionsService";
import { getSubscriptionFromCache } from "../selectors/subscriptionsCacheOperations";
import type { MailboxInfo } from "owa-client-types";
import { trace } from "owa-trace";
import type BrandSubscriptionModel from "../store/schema/BrandSubscriptionModel";

export default (smtpAddress: string, mailboxInfo: MailboxInfo): void => {
    const subscription = getSubscriptionFromCache(smtpAddress, mailboxInfo);
    if (subscription) {
        unsubscribeFromCache(subscription, smtpAddress, mailboxInfo);
    }
    else {
        // If there is no item in Cache, maybe it got stale so reload the Cache
        getBrandsSubscriptionsService(mailboxInfo, undefined /* dontLoadBrandsInfo */).catch(error => trace.warn(error));
    }
};

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
const unsubscribeFromCache = mutatorAction("unsubscribeFromCache", (subscription: BrandSubscriptionModel, smtpAddress: string, mailboxInfo: MailboxInfo) => {
    const accountStore = getBrandSubscriptionStoreForAccount(mailboxInfo);
    const key = smtpAddress.toLowerCase();
    
    accountStore.subscriptions.delete(key);
    accountStore.unsubscribedSubscriptions.set(key, subscription);
});
